import { useEffect } from 'react'

import { refreshSession } from '@/lib/httpClient'
import { useAuthStore } from '@/stores/authStore'
import type { AuthStatus } from '@/types/auth'

/**
 * No start da aplicação, tenta restaurar a sessão a partir do cookie httpOnly.
 * É o que faz o "manter conectado" funcionar entre visitas.
 * `refreshSession` já é single-flight, então o duplo-render do StrictMode é seguro.
 */
export function useSessionBootstrap(): AuthStatus {
  const status = useAuthStore((state) => state.status)

  useEffect(() => {
    void refreshSession().catch(() => {
      /* sem cookie / sessão inválida — refreshSession já marcou unauthenticated */
    })
  }, [])

  return status
}
